import { Component, OnInit, ViewChild } from '@angular/core';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { BookingModel, BookingService, CustomersService, PasswordReset, RecentBookings, UpdateCustomer, UpdateVehicle, UsersService, VehiclesService } from 'src/app/Api_Module';
import { FindCustomerResult } from '../../../Api_Module';
import { recentBookingResult } from '../../../Api_Module/model/recentBookingResult';
import { titles } from '../../../models/constants.model';
import { AuthenticationService } from '../../../services/authentication.service';
import { Quote } from '@angular/compiler';
import { BookingQuote } from 'src/app/models/booking.model';
import { Globals } from '../../../globals';


@Component({
  selector: 'crg-customer-dash',
  templateUrl: './customer-dash.component.html'
})
export class CustomerDashComponent implements OnInit {

  @ViewChild('bookingsTable') table: DatatableComponent;

  bookings: BookingModel[] = [];
  cache: BookingModel[] = [];
  //recentBookings: recentBookingResult[] = [];
  searchStr: string;
  filtervalue: string;
  alert: any;
  loading: boolean;
  loadingVehicles: boolean;
  vehicles: UpdateVehicle[] = [];
  recentQuotes: BookingQuote[];
  customer: UpdateCustomer;
  password: string;
  confirmPassword: string;

  messagesV = {emptyMessage: 'No Vehicles found. Try different parameters', totalMessage: 'Total Vehicles'};
  messages = {emptyMessage: 'No Bookings found. Try different parameters', totalMessage: 'Total Bookings'};

  titles: string[];

  constructor(public authServc: AuthenticationService, private customersService: CustomersService, private bookingService: BookingService,
    private toastr: ToastrService, private vehicleSrvc: VehiclesService, private usersSrvc: UsersService, private globals: Globals) {
  }

  ngOnInit() {
    this.autoDeleteOldQuotes();
    this.getCustomerFromId();
    this.getCustomerBookings();
    this.loading = true;
    this.titles = titles;

  }

  getRecentQuotes(): any[] {
    this.autoDeleteOldQuotes();
    if (!!localStorage.getItem('recentQuotes')) {
      this.recentQuotes = JSON.parse(localStorage.getItem('recentQuotes'));
    }
    return this.recentQuotes.sort((a, b) => {
      const aDate = new Date(a.date);
      const bDate = new Date(b.date);
      return bDate.getTime() > aDate.getTime() ? 1 : (bDate.getTime() < aDate.getTime() ? -1 : 0 );
    });
  }

  autoDeleteOldQuotes() {
    let recentQuotes: BookingQuote[] = JSON.parse(localStorage.getItem('recentQuotes'));
    if (recentQuotes) {
      recentQuotes = recentQuotes.filter( (quote: BookingQuote) => {
        if (!quote.id) {
          return false;
        }
        const autoDeleteDate = new Date(quote.expDate);
        autoDeleteDate.setHours( autoDeleteDate.getHours() + 24); // 48 Hours auto Delete
        return autoDeleteDate.getTime() >= new Date().getTime();
      });
    } else {
      recentQuotes = [];
    }
    localStorage.setItem('recentQuotes', JSON.stringify(recentQuotes));
  }

  getVihicleList(): {name: any, value: any}[] {
    const list: any[] = [];
    for (const vehicle of this.vehicles) {
      list.push({name: `${vehicle.registration} ${vehicle.make} ${vehicle.model} ${vehicle.color}`, value: vehicle.id});
    }
    return list;
  }

  getCustomerBookings() {
    this.customersService.getBookings(this.authServc.getCustomerId()).subscribe(resp => {
        this.loading = false;
        this.globals.recentBookings = resp;
        this.cache = resp;
      },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
  }

  getCustomerFromId() {
    this.customersService.get(this.authServc.getCustomerId()).subscribe((resp: FindCustomerResult) => {
        this.loading = false;
        if (!!resp) {
          this.customer = resp;
          this.vehicles = [ ...resp.cars ];
          // this.getCustomerVehicles();
        }
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Customer Details Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  bookFromQoute(event: string, quoteNumber) {
    console.log('bookFromQoute' + quoteNumber);
    // alert(JSON.stringify(event));
    // alert(JSON.stringify(this.recentQuotes[quoteNumber]));
      var quote = this.recentQuotes.find(fruit => fruit.id === quoteNumber);
      quote.booking.vehicleId = +event;
      this.createBooking(quote.booking, quoteNumber);
    }

    cancelBooking(id) {
        this.loading = true;
        this.bookingService.cancelBooking(id).subscribe(res => {
            this.loading = false;
            this.toastr.success('Booking cancelled!');
            this.getCustomerBookings();
        }, error => {
                this.loading = false;
                this.toastr.error('Something went wrong please try again later!');
            });
    }

  printInvoice(bookingId) {
    let popupWin;
    popupWin = window.open(`${this.bookingService.configuration.basePath}/api/Booking/${bookingId}/invoice`,
      '_blank', 'top=0,left=0,height=100%,width=auto');
  }

  printConfirmation(reference) {
    let popupWin;
    popupWin = window.open(`${this.bookingService.configuration.basePath}/api/Report/${reference}/confirmationReport`,
      '_blank', 'top=0,left=0,height=100%,width=auto');
  }

  saveCustomer() {
    this.customersService.put(this.customer).subscribe((resp: FindCustomerResult) => {
        this.loading = false;
        this.toastr.success('Details updated!');
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Customer Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  checkPasswords() {
    return this.password === this.confirmPassword;
  }


  changePassword() {
    const passwordreset: PasswordReset = {userId: this.authServc.getUserId(), password: this.password};
    this.usersSrvc.reset(passwordreset).subscribe((resp: FindCustomerResult) => {
        this.loading = false;
        this.toastr.success('Password updated!');
        this.password = '';
        this.confirmPassword = '';
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Customer Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  createBooking(booking, id: string) {
    this.alert = null;
    this.loading = true;

    booking.checkIn = new Date(booking.checkIn);
    booking.checkout = new Date(booking.checkout);
    booking.checkIn = this.convertUTCDateToLocalDate(booking.checkIn);
    booking.checkout = this.convertUTCDateToLocalDate(booking.checkout);
    console.log('book data' + JSON.stringify(booking));
    this.bookingService.createBooking(booking).subscribe(resp => {
        this.loading = false;
        // const booking: Booking = resp.body;
        this.toastr.success('Booking Captured, reference number : ' + resp.reference);
        this.removeQuote(id);
        this.getCustomerBookings();
      },
      error => {
        if (error[ 'status' ] === 404) {
          this.toastr.warning(error[ 'message' ]);
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        this.loading = false;
        this.toastr.error('Something went wrong. `-' + JSON.stringify(error.error) + '`');
        this.alert = {type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`'};
        console.log('error:' + JSON.stringify(error));
      });
  }

  convertUTCDateToLocalDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  isQuoteVaild(expdate: any) {
    if (!!expdate) {
      const quoteDate = new Date(expdate);
      return quoteDate.getTime() >= new Date().getTime();
    }
    return false;
  }

  removeQuote(id: string) {
    const recentQuotes = [];
    for (const quote of this.recentQuotes) {
      if (quote.id && quote.id !== id) {
        recentQuotes.push(quote);
      }
    }
    this.recentQuotes = recentQuotes;
    localStorage.setItem('recentQuotes', JSON.stringify(this.recentQuotes));
  }

  close(alert: any) {
    // this.alert = null;
  }
}
